<template>
    <th :style="{textAlign: align}" @click="onClick" class="report-column">
        {{ title }}
        <span>
            <ion-icon v-if="!sort || sort === 'asc'" name="caret-up-outline"></ion-icon>
            <ion-icon v-if="!sort || sort === 'desc'" name="caret-down-outline"></ion-icon>
        </span>
    </th>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            align: {
                type: String,
                default: 'left'
            },
            sort: {
                type: Number,
                default: null
            }
        },
        methods: {
            onClick() {
                this.$emit('click');
            }
        }
    }
</script>
<style scoped lang="scss">
    th.report-column {
        position: relative;
        cursor: pointer;
        padding: 10px 20px 10px 15px;

        span {
            position: absolute;
            right: 7px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            top: 50%;
            transform: translateY(-50%);

            ion-icon {
                height: 15px;
                font-size: 10px;

                &:nth-child(2) {
                    margin-top: -8px;
                }
            }
        }
    }
</style>
